module.exports = __webpack_public_path__ + "static/media/profile.87c0032b.jpg";